import { render, staticRenderFns } from "./register-dialog.vue?vue&type=template&id=2b07acbe&scoped=true&"
import script from "./register-dialog.vue?vue&type=script&lang=js&"
export * from "./register-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b07acbe",
  null
  
)

export default component.exports